import React from "react";
import Loader from "react-loader";

const ImageLoader = (props) => {
  return (
    <div className="loader-component">
      <Loader
        loaded={false}
        color="#fff"
        position="relative"
        className="image-loader"
      />
    </div>
  );
};

export default ImageLoader;
